import React from 'react';
import PropTypes from 'prop-types';
import { iconsMap } from 'utils/iconsMap';
import { ReactSVG } from 'react-svg';
import { activityTypeIconsMap } from 'utils/activityTypeIconsMap';

const DynamicIcon = ({
  type,
  name,
  color,
  fontSize,
  width,
  height,
  invert,
  fill,
  strokeWidth,
  forActivity,
  ...props
}) => {
  const Icon = forActivity
    ? activityTypeIconsMap[name]?.[type]
    : iconsMap[name]?.[type];
  if (!Icon) return null;
  // One `filter` declaration, since a second would replace the first. A caller
  // that passes its own `invert` (e.g. white on an active sidebar tile) has
  // picked the colour, so it wins. Otherwise the artwork takes the mono icon
  // filter so it reads in dark mode. Activity icons also get `grayscale`: the
  // Meet and call glyphs are colour bitmaps greyed by `mix-blend-mode:
  // luminosity`, and any filter on the <svg> isolates that blend from the page
  // behind it, which brings their colour back.
  const svgFilter =
    invert && invert !== 'none'
      ? invert
      : `${forActivity ? 'grayscale(100%) ' : ''}var(--dc-mono-icon-filter)`;
  return type === 'material' || type === 'material2' || forActivity ? (
    <ReactSVG
      src={Icon}
      wrapper="span"
      beforeInjection={(svg) => {
        svg.setAttribute(
          'style',
          `display: flex; align-items: center; gap:1;cursor: pointer;${
            width ? `width: ${width}px;` : 'width: 24px;'
          }${height ? `height: ${height}px;` : 'height: 24px;'}${
            color ? `color: ${color};` : ''
          }filter: ${svgFilter};${fill ? `fill: ${fill};` : ''}${
            strokeWidth ? `stroke-width: ${strokeWidth};` : ''
          }`,
        );
      }}
      {...props}
    />
  ) : (
    <Icon
      {...props}
      sx={
        type === 'material' || type === 'material2'
          ? {
              color: color,
              fontSize: fontSize,
            }
          : null
      }
      style={
        type === 'lucide' || !type
          ? {
              color: color,
              width: width,
              fill: fill,
              cursor: 'pointer',
            }
          : null
      }
    />
  );
};

DynamicIcon.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  invert: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
  forActivity: PropTypes.bool,
};

export default DynamicIcon;
